<template>
  <div class="unit text-center" v-if="unit.title">
    <div class="unit-title mt-3 mb-3">{{unit.title}}</div>
    <player class="ma-auto" v-if="unit.videoUrl && (unit.isFree || !isLocked)" :points="points" :videoId='unit.videoUrl'></player>
    <div v-else><strong>{{$t('settings.courses.noAccess')}}</strong></div>
    <!-- <magic-link-button v-if="!unit.isCompleted && showContinue" @click.native="$emit('complete')"/> -->

    <div v-if="(!unit.isCompleted && unit.videoViewedDate) || showNextInfo" class="mt-4">
      <strong v-if="unit.cardsToStudy === 0">
        {{$t('settings.courses.seeYouTomorrow')}}
      </strong>
      <strong v-else>
        {{$t('settings.courses.openNext')}}
      </strong>
    </div>
    <loader-button
      v-if="!unit.videoViewedDate && showContinue"
      :loading="loading"
      class="primary text-white mt-5 px-10 btn btn--sm"
      dark
      @click.stop.prevent="continueLearning"
    >
      <span v-if="unit.isFree">{{$t('settings.courses.nextUnit')}}</span>
      <span v-else>{{$t('settings.courses.continueInApp')}}</span>
    </loader-button>
  </div>
</template>

<script>
import player from '@/components/base/player';
import loaderButton from '@/components/base/loaderButton';
import toastr from '@/plugins/toastr';

export default {
  components: {
    player,
    loaderButton,
  },

  props: {
    unit: {
      type: Object,
      default: () => {},
    },

    isLocked: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      showNextInfo: false,
      showContinue: false,
      loading: false,
    };
  },

  watch: {
    'unit.videoUrl' () {
      this.showContinue = false;
    },
  },

  computed: {
    points () {
      return [
        {
          time: process.env.VUE_APP_ENV === 'dev' ? 10 : Infinity,
          cb: () => {
            if (!this.showContinue) {
              this.showContinue = true;
            }
          },
        },
      ];
    },
  },

  methods: {
    continueLearning () {
      this.loading = true;

      this.$emit('complete', () => {
        if (!this.unit.isFree) {
          this.showContinue = false;
          this.loading = false;
          this.showNextInfo = true;
          toastr.success('Cards added to learning deck. Continue in app.', null, 5000);

          return;
        }

        const language = this.$store.getters['languages/searchByCode']('es');
        this.$store.dispatch('user/GET_COURSES', language.id);
        this.$emit('next', this.unit.id);
        this.showContinue = false;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-title {
  font-size: 1.424rem;
  line-height: 2.136rem;
}
</style>
